export default {
  setContractScheduledRateChanges (state, changes) {
    state.contractScheduledRateChanges = changes
  }
}
